import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBRHeXLlETIw5YqmvsKkc6IEaZujou3kfA",
  authDomain: "priority-market-exchange.firebaseapp.com",
  projectId: "priority-market-exchange",
  storageBucket: "priority-market-exchange.firebasestorage.app",
  messagingSenderId: "913873060026",
  appId: "1:913873060026:web:058c36c43820e272d78283",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
